// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1_BxV","errorLogs":"styles_errorLogs__kvM68"};